// @flow
import React from 'react';
import classnames from 'classnames';
import { windowWrapper } from '@clubmed/utils';

import DynamicLinkUtil from 'Components/frameworks/dynamic-link/DynamicLinkUtil';
import { type BadgeProps } from 'Components/frameworks/badge/Badge';
import { ProductHeader } from 'Components/widgets/product/product-header/ProductHeader';
import { ProductFlag } from 'Components/widgets/product/product-flag/ProductFlag';
import { generateProductLink } from 'Components/widgets/product/Product.utils';
import { type PricingTableProps } from 'Components/frameworks/pricing-table/PricingTable.jsx';
import { useRouter } from 'Client/router/useRouter';

type ProductCondensedProps = {
  className?: string,
  header: {
    badgeIcon?: BadgeProps,
    heading: { title: string, subtitle?: string },
  },
  offer?: Offer,
  price: { [string]: * },
  pricingTable: PricingTableProps,
  url: string,
};

export function ProductCondensed(props: ProductCondensedProps) {
  const { className, header, price, pricingTable, offer, url } = props;

  const { history } = useRouter<{}, SearchQueryParams>();

  const goOnResort = () => {
    const newHistoryState = new DynamicLinkUtil(
      windowWrapper.getLocation(),
      url ? generateProductLink(url, offer) : '',
    );

    history.pushRoute(newHistoryState.toString());
  };

  return (
    <article className={classnames(className, 'flex flex-col absolute w-9/10 px-2 truncate')}>
      <ProductHeader {...header} className="pt-3" hasRelativeElement isLinkDisabled />
      <ProductFlag
        theme="compare"
        price={price}
        pricingTable={pricingTable}
        onClick={goOnResort}
        isLinkDisabled
      />
    </article>
  );
}
